export function syncLocalPlayerInfoMutedState(el, enabled) {
  el?.setAttribute?.("player-info", "muted", !enabled);
}
